module.exports = __webpack_public_path__ + "img/room.26e61d86.png";